<template>
  <div class="myEvaluate">
    <div class="head">
        <div style="flex:1;padding-left:20px;">
          <span style="flex:1;">宝贝</span>
        </div>
        <div style="flex:2;padding-right:20px;">
          <span style="flex:1;">评价时间</span>
          <span style="flex:1;">操作</span>
        </div>
    </div>
    <div class="sub-main">
        <div class="content" v-for="(item,index) in evaluateList" :key="index">
            <div class="productBox">
                <div class="product">
                    <div class="left fs13">
                        <div class="box">
                            <div class="desc">
                                <img :src="item.productImage.split(',h')[0]" alt="" @click="toProductDetail(item)">
                                <div>
                                    <p class="name" @click="toProductDetail(item)">{{item.productName}}</p>
                                    <p class="size font-color-999"><span v-for="(val,idx) in item.values" :key="idx">{{val}}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="time">
                            <p>{{item.createTime}}</p>
                        </div>
                        <div class="operate">
                            <div>
                                <p class="fs13 tex-und cur-poi" @click="toEvaluateDetail(item)">查看评价</p>
                                <p class="fs13 tex-und cur-poi" v-if="item.ifAdd==0" @click="toAddEvaluate(item)">去追评</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-pagination v-if="evaluateList.length>0" :current-page="page" :page-size="5" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='total'></el-pagination>
    </div>
  </div>
</template>
<script>
import api from '../../../api'
import {listSearchMixin} from '../../../config/mixin'
import {mapMutations} from 'vuex'
export default {
  mixins: [listSearchMixin],
  name: 'myEvaluate',
  data () {
    return {
      evaluateList: [],
      page: 1,
      total: 0
    }
  },
  mounted () {
    this.getEvaluateList()
  },
  methods: {
	  ...mapMutations({
	    setCurrentPro: 'SET_CURRENTPRO'
	  }),
    // 获取评价列表
    getEvaluateList () {
      const rLoading = this.openLoading()
      let self = this
      let params = {
          url: api.getEvaluateList + `?state=&page=${self.page}&limit=5`,
          method: 'GET',
          data: {
          }
        }
        self.sendReq(params, (res) => {
          if (res.success) {
              console.log("res",res);
              self.evaluateList = res.data.list;
                self.evaluateList.map(function(data){
                console.log(data);
                });




              self.total=res.data.total;
              // console.log(res)
              rLoading.close()
          } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
        })
    },
    // 查看评价
    toEvaluateDetail (item) {
		console.log(item)
        this.$router.push({
            path: '/evaluateDetail',
            query: {
                data: JSON.stringify(item)
            }
        })
    },
    // 去追评
    toAddEvaluate (item) {
        this.$router.push({
            path: '/addEvaluate',
            query: {
                data: JSON.stringify(item)
            }
        })
    },
    // 跳转到商品详情
    toProductDetail (item) {
		console.log(item)

		item.id = item.productId
		this.setCurrentPro(item)
		this.$router.push({path: '/productDetail?productId='+item.id})
        // this.$router.push({
        //     path: '/productDetail',
        //     query: {
        //         productId: id
        //     }
        // })
    },
    handleCurrentChange (val) {
      this.page = val
      this.getEvaluateList()
    }
  }
}
</script>
<style lang="scss" scoped>
.myEvaluate{
  width: 100%;
  .noorder{
        width: 100%;
        text-align: center;
        padding: 100px 0;
        p{
            margin-bottom: 20px;
        }
        .el-button{
            background-color: #D22929;
            color: #FFFFFF;
            font-weight: normal;
            border-radius: 0;
        }
    }
    .head{
      box-sizing: border-box;
      border: 1px solid #E5E5E5;
      width: 100%;
      height: 44px;
      background-color: #FFFFFF;
      display: flex;
      align-items: center;
      text-align: center;
      margin-bottom: 20px;
      div{
          display: flex;
      }
    }
    .content{
        width: 100%;
        margin-bottom: 10px;
        border: 1px solid #E5E5E5;
        border-bottom: 0;
        box-sizing: border-box;
        .productBox{
            width: 100%;
            box-sizing: border-box;
            .product{
                width: 100%;
                display: flex;
                .left{
                    flex: 1;
                    .box{
                        padding: 20px 0 20px 20px;
                        display: flex;
                        border-bottom: 1px solid #E5E5E5;
                        .desc{
                            flex: 1;
                            display: flex;
                            img{
                                width: 40px;
                                height: 40px;
                                margin-right: 10px;
                            }
                            div{
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                .name{
                                    font-size: 10px;
                                    &:hover {
                                      color:red;
                                    }
                                }
                                .size{
                                    font-size: 10px;
                                    span{
                                        margin-right: 10px;
                                    }
                                    span:last-child{
                                        margin-right: 0;
                                    }
                                }
                            }
                        }
                    }
                }
                .right{
                    padding: 5px 5px 5px 0;
                    flex: 2;
                    display: flex;
                    border-bottom: 1px solid #E5E5E5;
                    .operate{
                      &:hover {
                        color:blue;
                      }
                    }
                    .time,.operate{
                        flex: 1;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        p{
                          font-size: 10px;
                        }
                        div{
                            text-align: center;
                            .el-button{
                                border: 1px solid #D22929;
                                color: #D22929;
                                border-radius: 0;
                            }
                        }
                    }
                }
            }
        }
    }
    >>>.el-pagination{
        margin-top: 40px;
        text-align: right;
        .el-pager{
            li:not(.disabled):hover{
                color: #D22929;
            }
            li:not(.disabled).active{
                background-color: #D22929;
            }
            li:not(.disabled).active:hover{
                color: #F4F4F5;
            }
        }
    }
}
.sub-main{
    min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/myEvaluate/index.vue